module.exports = __webpack_public_path__ + "static/media/global-bg-2x.59bce5c8.png";